<mat-drawer-container class="drawer-container" autosize>

  <mat-drawer-content>

    <div class="container">
        <p class="title" style="margin: 0; text-align: center; color: darkgray;">
          Data Analytics
          <mat-icon class="titleIcon" style="margin-bottom: -7px;">chevron_right</mat-icon>Thermodynamic Model
        </p>
      <div class="toggle d-flex align-items-center gap-3">
        <mat-slide-toggle [checked]="isAdminView" (change)="toggleAdminView($event)">
          <span class="toggle-text">
            {{ isAdminView ? 'Custom Gradient Range' : 'Custom Gradient Range' }}
          </span>
        </mat-slide-toggle>
      </div>

      <!-- <p class="title">
    Data Analytics
    <mat-icon class="titleIcon">chevron_right</mat-icon>Heat Plan
  </p> -->

  <div class="action-header-container" #filterContainer>
        <div class="modern-action-bar" style="margin-left: 0; margin-right: 0;">
          <div class="spacer"></div>
          <div class="right-filters" style="width: 100%;">
            <form [formGroup]="myForm" class="filter-fields" style="width: 100%; display: flex; gap: 12px; align-items: flex-end;">
              
              <!-- Segment -->
              <div class="compact-multi-select">
                <div class="select-box" (click)="toggleSegmentDropdown($event)">
                  <span>{{ selectedSegments.length ? (selectedSegments.length === segmentOptions.length ? 'All Segments'
                    : selectedSegments.length + ' Segments') : 'Select Segment' }}</span>
                  <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-panel" *ngIf="segmentDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="search-container">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Search Segment..."
                      (input)="segmentSearchQuery = $any($event.target).value">
                  </div>
                  <div class="all-option" style="justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <input type="checkbox" (change)="toggleAllSegments($event)" [checked]="isAllSegmentsSelected()">
                      <span>Select All</span>
                    </div>
                    <span (click)="clearSegmentFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
                  </div>
                  <div class="options-list">
                    <div class="option" *ngFor="let seg of getFilteredSegments()">
                      <input type="checkbox" (change)="onSegmentCheckboxChange($event, seg)"
                        [checked]="selectedSegments.includes(seg)">
                      <span>{{ seg }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tanks -->
              <div class="compact-multi-select">
                <div class="select-box" (click)="toggleTankDropdown($event)">
                  <span>{{ selectedTanks.length ? (selectedTanks.length === tankOptions.length ? 'All Tanks'
                    : selectedTanks.length + ' Tanks') : 'Select Tank' }}</span>
                  <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-panel" *ngIf="tankDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="search-container">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Search Tank..."
                      (input)="tankSearchQuery = $any($event.target).value">
                  </div>
                  <div class="all-option" style="justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <input type="checkbox" (change)="toggleAllTanks($event)" [checked]="isAllTanksSelected()">
                      <span>Select All</span>
                    </div>
                    <span (click)="clearTankFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
                  </div>
                  <div class="options-list">
                    <div class="option" *ngFor="let tank of getFilteredTanks()">
                      <input type="checkbox" (change)="onTankCheckboxChange($event, tank)"
                        [checked]="selectedTanks.includes(tank)">
                      <span>{{ tank }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cargo Types -->
              <div class="compact-multi-select">
                <div class="select-box" (click)="toggleCargoDropdown($event)">
                  <span>{{ selectedCargoTypes.length ? (selectedCargoTypes.length === cargoOptions.length ? 'All Cargo'
                    : selectedCargoTypes.length + ' Cargo') : 'Select Cargo' }}</span>
                  <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-panel" *ngIf="cargoDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="search-container">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Search Cargo..."
                      (input)="cargoSearchQuery = $any($event.target).value">
                  </div>
                  <div class="all-option" style="justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <input type="checkbox" (change)="toggleAllCargos($event)" [checked]="isAllCargosSelected()">
                      <span>Select All</span>
                    </div>
                    <span (click)="clearCargoFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
                  </div>
                  <div class="options-list">
                    <div class="option" *ngFor="let cargo of getFilteredCargos()">
                      <input type="checkbox" (change)="onCargoCheckboxChange($event, cargo)"
                        [checked]="selectedCargoTypes.includes(cargo)">
                      <span>{{ cargo }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Heat Flag -->
              <div class="compact-multi-select">
                <div class="select-box" (click)="toggleHeatFlagDropdown($event)">
                  <span>{{ selectedHeatFlags.length ? (selectedHeatFlags.length === heatFlagOptions.length ? 'Both'
                    : selectedHeatFlags.join(', ')) : 'Select Flag' }}</span>
                  <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-panel" *ngIf="heatFlagDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="search-container">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Search Flag..."
                      (input)="heatFlagSearchQuery = $any($event.target).value">
                  </div>
                  <div class="all-option" style="justify-content: space-between;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <input type="checkbox" (change)="toggleAllHeatFlags($event)" [checked]="isAllHeatFlagsSelected()">
                      <span>Select All</span>
                    </div>
                    <span (click)="clearHeatFlagFilter($event)" style="cursor: pointer; color: #6366f1; font-size: 12px; font-weight: 600;">Clear All</span>
                  </div>
                  <div class="options-list">
                    <div class="option" *ngFor="let flag of getFilteredHeatFlags()">
                      <input type="checkbox" (change)="onHeatFlagCheckboxChange($event, flag)"
                        [checked]="selectedHeatFlags.includes(flag)">
                      <span>{{ flag }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gradient Range Min/Max (Admin Only) -->
              <div class="compact-multi-select" *ngIf="isAdminView" style="flex: 0.5; min-width: 80px;">
                <input type="text" class="form-control" formControlName="groupMin" placeholder="Min" style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
              </div>
              <div class="compact-multi-select" *ngIf="isAdminView" style="flex: 0.5; min-width: 80px;">
                <input type="text" class="form-control" formControlName="groupMax" placeholder="Max" style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
              </div>

              <!-- ACTIONS -->
              <div class="filter-action-btns">
                <button class="icon-btn clear" (click)="clearForm()" title="Reset Filters" type="button">
                  <mat-icon>clear_all</mat-icon>
                </button>
                <button class="icon-btn apply" (click)="fetchData()" title="Apply Filters" type="button">
                  <mat-icon>done</mat-icon>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <app-ch-skeleton *ngIf="isLoading" variant="tiles" [tiles]="4"></app-ch-skeleton>
      <div *ngIf="isLoading" style="margin-top: 16px;">
        <app-ch-skeleton variant="table" [rows]="8" [cols]="8"></app-ch-skeleton>
      </div>

      <div class="summary-stats-grid" *ngIf="!isLoading">
        <div class="summary-card"
             *ngFor="let stat of summaryStats"
             (click)="onStatClick(stat.label)"
             style="cursor: pointer">
          <div class="text-area">
            <div class="stat-title">{{ stat.label }}</div>
            <div class="stat-value">{{ stat.value }}</div>
          </div>
        </div>
      </div>

      <div class="charts-container" *ngIf="!isLoading">
        <div class="charts-grid">
          <div class="chart-card">
            <div class="chart-title">Standard Deviation Curve</div>
            <canvas id="standardDeviationChart"></canvas>
          </div>

          <div class="chart-card">
            <div class="chart-title">Std Dev Distribution</div>
            <div class="chart-flex">
              <canvas id="doughnutChart"></canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="filterBtn" *ngIf="!isLoading" style="text-align: left; margin-top: 0px">
        <button class="btn btn-primary d-flex align-items-center justify-content-center"
          style="min-width: 200px; height: 40px" (click)="downloadAllCharts()">
          <mat-icon class="me-2">download</mat-icon>
          Download PDF
        </button>
      </div>

      <div *ngIf="!isLoading && noDataFound" class="no-data-message">
        <p>No data found for the selected filters.</p>
      </div>

      <button class="table-fab" *ngIf="!isLoading" (click)="openVoyageDrawer()" matTooltip="Overall Drop Analysis">
        <mat-icon>table_view</mat-icon>
      </button>

    </div>

  </mat-drawer-content>


  <mat-drawer
    #voyageDrawer
    mode="over"
    position="end"
    class="drawer-panel">

    <div class="drawer-shell">

      <div class="drawer-header">
        <div class="drawer-title">
          <div class="drawer-main-title">Gradient Wise - Temperature Drop</div>
          <!-- <div class="drawer-subtitle">Detailed View</div> -->
        </div>

        <button class="drawer-close-btn" (click)="voyageDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- <div class="drawer-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" placeholder="Search Vessel / IMO / Segment..." (input)="applyFilter($event)" />
      </div> -->

   <div class="drawer-table">



  <div class="drawer-table-scroll">

    <table class="ship-table dark-table">
     <thead>
  <tr class="group-row">
    <th rowspan="2" class="first-col">Gradient Range</th>

    <th *ngFor="let group of segmentGroups"
        [attr.colspan]="group.columns.length"
        class="group-head">
      {{ group.name }}
    </th>
  </tr>

  <tr class="sub-row">
    <ng-container *ngFor="let group of segmentGroups">
      <th *ngFor="let tank of group.tanks">
        {{ tank }}
      </th>
    </ng-container>
  </tr>
</thead>


     <tbody>
  <tr *ngFor="let row of filteredVoyageRows; let i = index">
    <td class="first-col">{{ row.gradientRange }}</td>

    <ng-container *ngFor="let group of segmentGroups">
      <td *ngFor="let colKey of group.columns">
        {{ row[colKey] }}
      </td>
    </ng-container>
  </tr>

  <tr *ngIf="filteredVoyageRows.length === 0">
    <td [attr.colspan]="getTotalColSpan()" class="no-row">
      No data available
    </td>
  </tr>
</tbody>

    </table>

  </div>
</div>



    </div>

  </mat-drawer>

</mat-drawer-container>
